import script from "./budget-set-imports-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./budget-set-imports-modal.vue?vue&type=script&setup=true&lang=ts"

import "./budget-set-imports-modal.vue?vue&type=style&index=0&id=75a8b7c2&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75a8b7c2"]])

export default __exports__